import React from 'react';
import './SingleGallery.css';
import { Link } from 'react-router-dom';
import { Gallery } from '../Gallery.interface';
import { linkize, removeDiacritics } from 'libs/functions/string-operations';
import { environments } from 'environments/environments';
import imageFacebook from 'assets/img/Facebook_icon.svg';


const SingleGallery = (props: { gallery: Gallery }) => {
  const linkName = linkize(removeDiacritics(props.gallery.name), '-');
  const linkHref = props.gallery.link || `/fotky/${props.gallery.id}-${linkName}`;
  const renderImage = props.gallery.mainphoto
    ? props.gallery.mainphoto.startsWith('http')
      ? <img src={props.gallery.mainphoto} alt={props.gallery.name} />
      : <img src={`${environments.server}/${props.gallery.mainphoto}`} alt={props.gallery.name} />
    : null;
  const externalLinkIcon = props.gallery.link
    ? props.gallery.link.includes('facebook')
      ? <img className='external-album' src={imageFacebook} alt="Facebookové album" />
      : <span className='external-album'>⧉</span>
    : null;
  const cardPhoto = <div className="gallery-card-photo" id="gallerimage_">{renderImage}{externalLinkIcon}</div>
  const cardName = <p className="gallery-card-name">{props.gallery.name ? props.gallery.name.replace(/&quot;/g, '"') : ""}</p>
  const link = props.gallery.link
    ? <a href={linkHref} target="_blank" rel="noopener noreferrer" className="section gallery-card" >
      {cardPhoto}
      {cardName}
    </a>
    : <Link to={linkHref} className="section gallery-card" >
      {cardPhoto}
      {cardName}
    </Link>

  return (
    link
  )
}

export default SingleGallery